import React, { lazy } from 'react';
interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
export const Logo = ({
  size = 'md',
  className = ''
}: LogoProps) => {
  const widths = {
    sm: 110,
    md: 160,
    lg: 220
  };
  return <img src="https://cdn.magicpatterns.com/uploads/4uPBzNpH6m9EY4gNp874BD/LOGO_SKIN_GLOW.png" alt="Skin Glow Studio 22 — Spa & Beauty" width={widths[size]} className={`h-auto block mix-blend-darken ${className}`} loading="lazy" decoding="async" style={{
    width: widths[size],
    filter: 'contrast(1.25) saturate(1.35) brightness(1.04)'
  }} data-id="element-354" />;
};